import { API_BASE_URL } from "../../config";

async function fetchElectricityPricesData() {
  try {
    const response = await fetch(`${API_BASE_URL}/electricity`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching electricity prices data:', error);
    return [];
  }
}

export const electricityPricesData = await fetchElectricityPricesData();
